export const CHANGE_ACCOUNT_PAGE = 'CHANGE_ACCOUNT_PAGE'

export function changeAccountPage(page) {
  return {
    type: CHANGE_ACCOUNT_PAGE,
    page
  }
}
